import { Injectable } from '@angular/core';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { MediumTypeEnum } from '../enums/medium-type.enum';
import {SessionStorageKeysEnum} from '../models/session-storage-keys-enum';

@Injectable()
export class ChannelService {

    constructor(
        private sessionStorageService: BdbSessionStrgService
    ) { }

    public getChannel() {
        let channel;
        const mediumTypeNumber = Number(this.sessionStorageService.get(SessionStorageKeysEnum.MEDIUM_TYPE));
        if (mediumTypeNumber === MediumTypeEnum.ALLIED) {
            channel = 'Aliado';
        } else if (mediumTypeNumber === MediumTypeEnum.FAIR) {
            channel = 'Feria'
        } else if (mediumTypeNumber === MediumTypeEnum.MOBILE_FORCE) {
            channel = 'FMV';
        } else if (mediumTypeNumber === MediumTypeEnum.OFFICE) {
            channel = 'Oficina';
        } else if (mediumTypeNumber === MediumTypeEnum.POSTSALES) {
            channel = 'Postventa';
        } else if (mediumTypeNumber === MediumTypeEnum.MICROFINANCES) {
            channel = 'MFZ';
        } else {
            channel = 'Otro';
        }
        console.log('Saving channel: ', channel);
        this.sessionStorageService.save(SessionStorageKeysEnum.CHANNEL, channel);
        return channel;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/channel.service.ts